import {
  getBaseYearEndBounds,
  getBaseYearStartDate,
  getReportYearEndBounds,
  getReportYearStartDate,
} from "../utils";

const formatDateDisplay = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const validateNxmapForm = (
  form = {},
  baseYearEndBounds,
  t,
  reportYearEndBounds,
  { step = 3 } = {},
) => {
  const message = (text) => (typeof t === "function" ? t(text) : text);
  const errors = {};

  const thresholdRaw = String(form.threshold ?? "").trim();
  const thresholdNum = Number(thresholdRaw);

  const shouldCheckStep = (targetStep) => Number(step) >= targetStep;

  if (shouldCheckStep(1)) {
    if (!form.organizationBoundary) {
      errors.organizationBoundary = message("Select organization boundary.");
    }
    if (!form.ghgReportPurpose) {
      errors.ghgReportPurpose = message("Select GHG reporting purpose.");
    }
    if (!thresholdRaw) {
      errors.threshold = message("Enter disclosure threshold (3-25).");
    } else if (Number.isNaN(thresholdNum)) {
      errors.threshold = message("Threshold must be a number.");
    } else if (thresholdNum < 3 || thresholdNum > 25) {
      errors.threshold = message("Threshold must be between 3 and 25.");
    }
    if (!form.reportingStandard) {
      errors.reportingStandard = message("Select reporting standard.");
    }
    if (!form.baseYear) {
      errors.baseYear = message("Select base year.");
    }
    if (!form.baseYearStart) {
      errors.baseYearStart = message("Select base year period start.");
    }
    if (!form.baseYearEnd) {
      errors.baseYearEnd = message("Select base year period end.");
    }
    if (!form.reportingYear) {
      errors.reportingYear = message("Select report year.");
    }
    if (!form.reportingPeriodStart) {
      errors.reportingPeriodStart = message("Select report year period start.");
    }
    if (!form.reportingPeriodEnd) {
      errors.reportingPeriodEnd = message("Select report year period end.");
    }
  }

  if (form.baseYear && form.baseYearStart) {
    const jan1 = new Date(`${form.baseYear}-01-01`);
    if (new Date(form.baseYearStart) < jan1) {
      errors.baseYearStart = message(
        "Start date cannot be earlier than January 1 of the base year.",
      );
    }
  }

  const resolvedBounds =
    baseYearEndBounds ||
    getBaseYearEndBounds(
      form.baseYearStart,
      getBaseYearStartDate(form.baseYear),
    );

  if (
    form.baseYearEnd &&
    resolvedBounds?.min &&
    form.baseYearEnd < resolvedBounds.min
  ) {
    errors.baseYearEnd = message(
      `End date should not be earlier than ${formatDateDisplay(resolvedBounds.min)}.`,
    );
  } else if (
    form.baseYearEnd &&
    resolvedBounds?.max &&
    form.baseYearEnd > resolvedBounds.max
  ) {
    errors.baseYearEnd = message(
      `End date should not be later than ${formatDateDisplay(resolvedBounds.max)}.`,
    );
  }

  if (form.reportYear && form.reportYearStart) {
    const jan1 = new Date(`${form.reportYear}-01-01`);
    if (new Date(form.reportYearStart) < jan1) {
      errors.reportYearStart = message(
        "Start date cannot be earlier than January 1 of the report year.",
      );
    }
  }

  const resolvedReportBounds =
    reportYearEndBounds ||
    getReportYearEndBounds(
      form.reportYearStart,
      getReportYearStartDate(form.reportYear),
    );

  if (
    form.reportYearEnd &&
    resolvedReportBounds?.min &&
    form.reportYearEnd < resolvedReportBounds.min
  ) {
    errors.reportYearEnd = message(
      `End date should not be earlier than ${formatDateDisplay(resolvedReportBounds.min)}.`,
    );
  } else if (
    form.reportYearEnd &&
    resolvedReportBounds?.max &&
    form.reportYearEnd > resolvedReportBounds.max
  ) {
    errors.reportYearEnd = message(
      `End date should not be later than ${formatDateDisplay(resolvedReportBounds.max)}.`,
    );
  }

  return errors;
};
